import { trpc } from "@blis/trpc/react";

import { SearchableSelect } from "@/components/ui/searchable-select";

export function BillToSelect({
  value,
  onChange,
  orgId,
}: {
  value?: number;
  onChange: (value: number | undefined) => void;
  orgId: number;
}) {
  const { data } = trpc.accession.billableOrgs.useQuery(
    { orgId },
    {
      enabled: !!orgId,
    },
  );
  const options = data || [];
  const hasValue = typeof value === "number" && !Number.isNaN(value);
  const selectedKeys = hasValue ? new Set([value]) : new Set<number>();

  return (
    <SearchableSelect
      selectionMode="single"
      selectedKeys={selectedKeys}
      onSelectionChange={(keys) => {
        if (keys === "all") return;
        const first = keys.values().next().value;
        if (keys.size === 0) {
          onChange(undefined);
        } else if (typeof first === "number" && !Number.isNaN(first)) {
          onChange(first);
        } else {
          onChange(undefined);
        }
      }}
      renderEmptyState={() => (
        <div className="p-2 text-muted-foreground text-xs">
          No billing organizations found
        </div>
      )}
    >
      <SearchableSelect.Button
        isDisabled={options.length === 0}
        isClearable
        className="justify-between"
      >
        <SearchableSelect.Value
          items={options}
          getKey={(item) => item.id}
          getText={(item) => item.name}
          placeholder="None"
          className="flex-1 text-start"
        />
      </SearchableSelect.Button>
      <SearchableSelect.Popover placement="bottom end">
        <SearchableSelect.Input placeholder="Search billing organizations..." />
        <SearchableSelect.List items={options} shouldFocusOnHover>
          {(item) => (
            <SearchableSelect.Item id={item.id} textValue={item.name}>
              {item.name}
            </SearchableSelect.Item>
          )}
        </SearchableSelect.List>
      </SearchableSelect.Popover>
    </SearchableSelect>
  );
}
